<template>
  <v-layout column class="ticket-price-container">
    <v-flex style="margin-bottom: 20px">
      <v-layout row wrap>
        <div
          class="price-container-title"
          :style="{ color: getThemeStyle(event.coverImagePrimaryColor) }"
        >
          Prihvaćamo sljedeće debitne i kreditne kartice
        </div>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout>
        <img class="card-image" src="../../../../public/assets/visa.png" alt="sad_cloud">
        <img class="card-image" src="../../../../public/assets/mastercard.png" alt="sad_cloud">
        <img class="card-image" src="../../../../public/assets/maestro.png" alt="sad_cloud">
        <img class="card-image" src="../../../../public/assets/diners.png" alt="sad_cloud">
        <img class="card-image" src="../../../../public/assets/discovery.png" alt="sad_cloud">
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'credit-card-company-logos',
  props: {
    event: {
      type: Object,
    },
  },
  watch: {
    step: function () {},
  },
}
</script>

<style scoped>
.card-image {
  height: 24px;
  margin-right: 12px;
}
.ticket-price-container {
  background: #f5f5f5;
  padding: 24px 30px 24px 24px;
  border-radius: 8px;
  position: relative;
  margin: 20px 0 0 0;
}
.ticket-price-container-step {
  margin: 32px 0 0;
}

@media screen and (max-width: 992px) {
  .ticket-price-container {
    margin: 12px;
  }
  .ticket-price-container-step {
    margin: 32px 12px 12px 12px;
  }
}
@media (min-width: 992px) and (max-width: 1440px) {
  .ticket-price-container {
    border-radius: 8px 0 0 8px;
  }
}

.price-container-title {
  font-family: Raleway, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
}

@media screen and (max-width: 375px) {
  .ticket-price-container {
    width: fit-content;
  }
  .card-image {
    display: block;
    margin: 0 auto;
  }
}
</style>
